module.exports = __webpack_public_path__ + "img/plugin-how-it-works-info_2_mobile.d7a2d1f5.svg";